import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateModalConfirm } from 'src/app/modules/translate-app/translate-modal-confirm';
import { ICulture, IXenaApp, IXenaAppBundle } from 'src/app/xena-api';

@Component({
    selector: 'app-target-selection',
    templateUrl: './target-selection.component.html',
    styleUrls: ['./target-selection.component.scss'],
    standalone: false
})
export class TargetSelectionComponent {
  usedCultures: ICulture[] = [];
  unusedCultures: ICulture[] = [];
  sourceCultureFriendlyName: string;

  _app: IXenaApp | IXenaAppBundle;
  get app() { return this._app; }

  @Input() set app(app: IXenaApp | IXenaAppBundle) {
    if (this.app != app) {
      this._app = app;
      this.culturesChanged();
    }
  }

  _cultures: ICulture[];
  get cultures() { return this._cultures; }

  @Input() set cultures(cultures: ICulture[]) {
    if (this.cultures != cultures) {
      this._cultures = cultures;
      this.culturesChanged();
    }
  }

  @Input() selectedCulture: ICulture;
  @Input() hasUnsaved: () => boolean;
  @Output() selectedCultureChange: EventEmitter<ICulture> = new EventEmitter<ICulture>();

  culturesChanged(): void {
    if (!this.app || !this.cultures) return;

    this.sourceCultureFriendlyName = this.cultures.find(c => c.culture === this.app.culture)?.name || '';
    this.usedCultures = this.cultures.filter(c => c.culture in this.app.translations);
    this.unusedCultures = this.cultures.filter(c => !(c.culture in this.app.translations) && c.culture !== this.app.culture);
  }

  select(selectedValue: CustomEvent): void {
    if (this.selectedCulture && selectedValue.detail == this.selectedCulture.culture) return;

    if (this.hasUnsaved()) {
      TranslateModalConfirm.open().then(result => {
        if (!result) {
          const targetElement: any = selectedValue.target;
          targetElement.value = this.selectedCulture.culture;
        } else {
          this.handleSelect(selectedValue);
        }
      });

      return;
    }

    this.handleSelect(selectedValue);
  }

  handleSelect(value: CustomEvent): void {
    const culture = this.selectedCulture = this.cultures.find(c => c.culture === value.detail);
    this.selectedCulture = culture;
    this.selectedCultureChange.emit(culture);
  }
}
